// extracted by mini-css-extract-plugin
module.exports = {"widgetWrapper":"widget-module__widgetWrapper__2USeE"};